var React = require('react');

function SpotifyInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.09 7.51a.51.51 0 01-.26-.07 7.49 7.49 0 00-3.67-.85 7.75 7.75 0 00-2 .24 1.1 1.1 0 01-.26.06.47.47 0 01-.47-.48.49.49 0 01.35-.48 8.4 8.4 0 012.37-.3 8.46 8.46 0 014.14 1 .47.47 0 01.26.45.46.46 0 01-.46.43zm-.62 1.54a.4.4 0 01-.25-.05A6.36 6.36 0 007 8.16a6.33 6.33 0 00-1.63.21.77.77 0 01-.24.06.41.41 0 01-.08-.81 6.7 6.7 0 012-.28 7 7 0 013.57.93.39.39 0 01.23.39.38.38 0 01-.38.39zm-.55 1.32a.35.35 0 01-.21-.07 5 5 0 00-2.58-.67 7.43 7.43 0 00-1.58.18H5.3a.31.31 0 01-.3-.27.32.32 0 01.27-.34A8.39 8.39 0 017.13 9a5.61 5.61 0 012.87.73.34.34 0 01.2.33.31.31 0 01-.28.31zM8 3a5 5 0 105 5 5 5 0 00-5-5z","fill":"currentColor"}));
}

SpotifyInline.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = SpotifyInline;

SpotifyInline.default = SpotifyInline;
